type HorizontalRect = Pick<DOMRect, 'left' | 'width'>
type TabPositionElement = {
  getBoundingClientRect: () => HorizontalRect
}
type ScrollableTabsElement = TabPositionElement & {
  scrollBy: (options: ScrollToOptions) => void
}

export const getTabCenterScrollDelta = (tabsRect: HorizontalRect, targetRect: HorizontalRect) => {
  const tabsCenter = tabsRect.left + tabsRect.width / 2
  const targetCenter = targetRect.left + targetRect.width / 2

  return targetCenter - tabsCenter
}

export const scrollTabToCenter = (tabsEl: ScrollableTabsElement, targetTab: TabPositionElement) => {
  const delta = getTabCenterScrollDelta(tabsEl.getBoundingClientRect(), targetTab.getBoundingClientRect())

  if (Math.abs(delta) <= 0.5) {
    return
  }

  tabsEl.scrollBy({ left: delta, behavior: 'smooth' })
}
